var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};

// ../../node_modules/id3js/lib/reader.js
var Reader;
var init_reader = __esm({
  "../../node_modules/id3js/lib/reader.js"() {
    Reader = class {
      constructor() {
        this.size = 0;
      }
      /**
       * Closes the resource
       * @return {Promise<void>}
       */
      async close() {
        return;
      }
      /**
       * Reads a specified range into a Blob
       * @param {number} length Number of bytes to read
       * @param {number} position Position to begin from
       * @param {string=} type Type of data to return
       * @return {Promise<Blob>}
       */
      async readBlob(length, position = 0, type = "application/octet-stream") {
        const data = await this.read(length, position);
        return new Blob([data], { type });
      }
    };
  }
});

// ../../node_modules/id3js/lib/genres.js
var genres = [
  "Blues",
  "Classic Rock",
  "Country",
  "Dance",
  "Disco",
  "Funk",
  "Grunge",
  "Hip-Hop",
  "Jazz",
  "Metal",
  "New Age",
  "Oldies",
  "Other",
  "Pop",
  "R&B",
  "Rap",
  "Reggae",
  "Rock",
  "Techno",
  "Industrial",
  "Alternative",
  "Ska",
  "Death Metal",
  "Pranks",
  "Soundtrack",
  "Euro-Techno",
  "Ambient",
  "Trip-Hop",
  "Vocal",
  "Jazz+Funk",
  "Fusion",
  "Trance",
  "Classical",
  "Instrumental",
  "Acid",
  "House",
  "Game",
  "Sound Clip",
  "Gospel",
  "Noise",
  "AlternRock",
  "Bass",
  "Soul",
  "Punk",
  "Space",
  "Meditative",
  "Instrumental Pop",
  "Instrumental Rock",
  "Ethnic",
  "Gothic",
  "Darkwave",
  "Techno-Industrial",
  "Electronic",
  "Pop-Folk",
  "Eurodance",
  "Dream",
  "Southern Rock",
  "Comedy",
  "Cult",
  "Gangsta Rap",
  "Top 40",
  "Christian Rap",
  "Pop / Funk",
  "Jungle",
  "Native American",
  "Cabaret",
  "New Wave",
  "Psychedelic",
  "Rave",
  "Showtunes",
  "Trailer",
  "Lo-Fi",
  "Tribal",
  "Acid Punk",
  "Acid Jazz",
  "Polka",
  "Retro",
  "Musical",
  "Rock & Roll",
  "Hard Rock",
  "Folk",
  "Folk-Rock",
  "National Folk",
  "Swing",
  "Fast  Fusion",
  "Bebob",
  "Latin",
  "Revival",
  "Celtic",
  "Bluegrass",
  "Avantgarde",
  "Gothic Rock",
  "Progressive Rock",
  "Psychedelic Rock",
  "Symphonic Rock",
  "Slow Rock",
  "Big Band",
  "Chorus",
  "Easy Listening",
  "Acoustic",
  "Humour",
  "Speech",
  "Chanson",
  "Opera",
  "Chamber Music",
  "Sonata",
  "Symphony",
  "Booty Bass",
  "Primus",
  "Porn Groove",
  "Satire",
  "Slow Jam",
  "Club",
  "Tango",
  "Samba",
  "Folklore",
  "Ballad",
  "Power Ballad",
  "Rhythmic Soul",
  "Freestyle",
  "Duet",
  "Punk Rock",
  "Drum Solo",
  "A Cappella",
  "Euro-House",
  "Dance Hall",
  "Goa",
  "Drum & Bass",
  "Club-House",
  "Hardcore",
  "Terror",
  "Indie",
  "BritPop",
  "Negerpunk",
  "Polsk Punk",
  "Beat",
  "Christian Gangsta Rap",
  "Heavy Metal",
  "Black Metal",
  "Crossover",
  "Contemporary Christian",
  "Christian Rock",
  "Merengue",
  "Salsa",
  "Thrash Metal",
  "Anime",
  "JPop",
  "Synthpop",
  "Rock/Pop"
];
var genres_default = genres;

// ../../node_modules/id3js/lib/util.js
function getString(view, length, offset = 0, raw) {
  let len = length || view.byteLength - offset;
  const useBuffer = typeof Buffer !== "undefined";
  if (len < 0) {
    len += view.byteLength;
  }
  const data = [];
  const limit = offset + len;
  for (let i = offset; i < limit; i++) {
    const current = view.getUint8(i);
    if (current === 0) {
      break;
    }
    data.push(current);
  }
  if (useBuffer) {
    return Buffer.from(data).toString();
  }
  const str = data.map((chr) => String.fromCharCode(chr)).join("");
  if (raw) {
    return str;
  }
  return decodeURIComponent(escape(str));
}
function getStringUtf16(view, length, offset = 0, bom) {
  let littleEndian = false;
  let len = length || view.byteLength - offset;
  const str = [];
  const useBuffer = typeof Buffer !== "undefined";
  if (len < 0) {
    len += view.byteLength;
  }
  if (offset + 1 > view.byteLength) {
    return "";
  }
  if (bom) {
    const bomInt = view.getUint16(offset);
    if (bomInt === 65534) {
      littleEndian = true;
    }
    offset += 2;
    len -= 2;
  }
  const limit = offset + len;
  for (let i = offset; i < limit; i += 2) {
    let ch = view.getUint16(i, littleEndian);
    if (i < limit - 1 && ch === 0 && view.getUint16(i + 1, littleEndian) === 0) {
      break;
    }
    if (ch >= 0 && ch <= 55295 || ch >= 57344 && ch <= 65535) {
      str.push(ch);
    } else if (ch >= 65536 && ch <= 1114111) {
      ch -= 65536;
      str.push(((1047552 & ch) >> 10) + 55296);
      str.push((1023 & ch) + 56320);
    }
  }
  if (useBuffer) {
    const buf = Buffer.alloc(str.length * 2);
    for (let i = 0; i < str.length; i++) {
      const chr = str[i];
      if (littleEndian) {
        buf.writeUInt16LE(chr, i * 2);
      } else {
        buf.writeUInt16BE(chr, i * 2);
      }
    }
    return buf.toString();
  }
  return String.fromCharCode.apply(null, new Uint16Array(str));
}
function getSynch(num) {
  let out = 0;
  let mask = 2130706432;
  while (mask) {
    out >>= 1;
    out |= num & mask;
    mask >>= 8;
  }
  return out;
}
function getUint32Synch(view, offset = 0) {
  return getSynch(view.getUint32(offset));
}
function getUint24(view, offset = 0, littleEndian) {
  if (littleEndian) {
    return view.getUint8(offset) + (view.getUint8(offset + 1) << 8) + (view.getUint8(offset + 2) << 16);
  }
  return view.getUint8(offset + 2) + (view.getUint8(offset + 1) << 8) + (view.getUint8(offset) << 16);
}

// ../../node_modules/id3js/lib/id3Frame.js
var types = /* @__PURE__ */ new Map([
  /*
   * Textual frames
   */
  ["TALB", "album"],
  ["TBPM", "bpm"],
  ["TCOM", "composer"],
  ["TCON", "genre"],
  ["TCOP", "copyright"],
  ["TDEN", "encoding-time"],
  ["TDLY", "playlist-delay"],
  ["TDOR", "original-release-time"],
  ["TDRC", "recording-time"],
  ["TDRL", "release-time"],
  ["TDTG", "tagging-time"],
  ["TENC", "encoder"],
  ["TEXT", "writer"],
  ["TFLT", "file-type"],
  ["TIPL", "involved-people"],
  ["TIT1", "content-group"],
  ["TIT2", "title"],
  ["TIT3", "subtitle"],
  ["TKEY", "initial-key"],
  ["TLAN", "language"],
  ["TLEN", "length"],
  ["TMCL", "credits"],
  ["TMED", "media-type"],
  ["TMOO", "mood"],
  ["TOAL", "original-album"],
  ["TOFN", "original-filename"],
  ["TOLY", "original-writer"],
  ["TOPE", "original-artist"],
  ["TOWN", "owner"],
  ["TPE1", "artist"],
  ["TPE2", "band"],
  ["TPE3", "conductor"],
  ["TPE4", "remixer"],
  ["TPOS", "set-part"],
  ["TPRO", "produced-notice"],
  ["TPUB", "publisher"],
  ["TRCK", "track"],
  ["TRSN", "radio-name"],
  ["TRSO", "radio-owner"],
  ["TSOA", "album-sort"],
  ["TSOP", "performer-sort"],
  ["TSOT", "title-sort"],
  ["TSRC", "isrc"],
  ["TSSE", "encoder-settings"],
  ["TSST", "set-subtitle"],
  /*
   * Textual frames (<=2.2)
   */
  ["TAL", "album"],
  ["TBP", "bpm"],
  ["TCM", "composer"],
  ["TCO", "genre"],
  ["TCR", "copyright"],
  ["TDY", "playlist-delay"],
  ["TEN", "encoder"],
  ["TFT", "file-type"],
  ["TKE", "initial-key"],
  ["TLA", "language"],
  ["TLE", "length"],
  ["TMT", "media-type"],
  ["TOA", "original-artist"],
  ["TOF", "original-filename"],
  ["TOL", "original-writer"],
  ["TOT", "original-album"],
  ["TP1", "artist"],
  ["TP2", "band"],
  ["TP3", "conductor"],
  ["TP4", "remixer"],
  ["TPA", "set-part"],
  ["TPB", "publisher"],
  ["TRC", "isrc"],
  ["TRK", "track"],
  ["TSS", "encoder-settings"],
  ["TT1", "content-group"],
  ["TT2", "title"],
  ["TT3", "subtitle"],
  ["TXT", "writer"],
  /*
   * URL frames
   */
  ["WCOM", "url-commercial"],
  ["WCOP", "url-legal"],
  ["WOAF", "url-file"],
  ["WOAR", "url-artist"],
  ["WOAS", "url-source"],
  ["WORS", "url-radio"],
  ["WPAY", "url-payment"],
  ["WPUB", "url-publisher"],
  /*
   * URL frames (<=2.2)
   */
  ["WAF", "url-file"],
  ["WAR", "url-artist"],
  ["WAS", "url-source"],
  ["WCM", "url-commercial"],
  ["WCP", "url-copyright"],
  ["WPB", "url-publisher"],
  /*
   * Comment frame
   */
  ["COMM", "comments"],
  /*
   * Image frame
   */
  ["APIC", "image"],
  ["PIC", "image"],
  /*
   * Private frames
   */
  ["PRIV", "private"]
]);
var imageTypes = [
  "other",
  "file-icon",
  "icon",
  "cover-front",
  "cover-back",
  "leaflet",
  "media",
  "artist-lead",
  "artist",
  "conductor",
  "band",
  "composer",
  "writer",
  "location",
  "during-recording",
  "during-performance",
  "screen",
  "fish",
  "illustration",
  "logo-band",
  "logo-publisher"
];
function parseLegacy(buffer) {
  const result = {
    id: null,
    tag: null,
    value: null
  };
  const dv = new DataView(buffer);
  const header = {
    id: getString(dv, 3),
    type: getString(dv, 1),
    size: getUint24(dv, 3)
  };
  const matchedType = types.get(header.id);
  if (!matchedType) {
    return null;
  }
  result.id = header.id;
  result.tag = matchedType;
  if (header.type === "T") {
    let val = getString(dv, -7, 7);
    if (header.id === "TCO" && !!parseInt(val)) {
      val = genres_default[parseInt(val)];
    }
    result.value = val;
  } else if (header.type === "W") {
    result.value = getString(dv, -7, 7);
  } else if (header.id === "COM") {
    let val = getString(dv, -10, 10);
    if (val.indexOf("\0") !== -1) {
      val = val.substr(val.indexOf("\0") + 1);
    }
    result.value = val;
  } else if (header.id === "PIC") {
    const image = {
      type: null,
      mime: "image/" + getString(dv, 3, 7).toLowerCase(),
      description: null,
      data: null
    };
    image.type = imageTypes[dv.getUint8(11)] || "other";
    const variableStart = 11;
    let variableLength = 0;
    for (let i = variableStart; ; i++) {
      if (dv.getUint8(i) === 0) {
        variableLength = i - variableStart;
        break;
      }
    }
    image.description = variableLength === 0 ? null : getString(dv, variableLength, variableStart);
    image.data = buffer.slice(variableStart + 1);
    result.value = image;
  }
  return result.tag ? result : null;
}
function parse(buffer, major, minor) {
  minor = minor || 0;
  major = major || 4;
  const result = { id: null, tag: null, value: null };
  const dv = new DataView(buffer);
  if (major < 3) {
    return parseLegacy(buffer);
  }
  const header = {
    id: getString(dv, 4),
    type: getString(dv, 1),
    size: getUint32Synch(dv, 4),
    flags: [dv.getUint8(8), dv.getUint8(9)]
  };
  if (header.flags[1] !== 0) {
    return null;
  }
  const matchedType = types.get(header.id);
  if (!matchedType) {
    return null;
  }
  result.tag = matchedType;
  result.id = header.id;
  if (header.type === "T") {
    const encoding = dv.getUint8(10);
    let val = null;
    if (encoding === 0 || encoding === 3) {
      val = getString(dv, -11, 11);
    } else if (encoding === 1) {
      val = getStringUtf16(dv, -11, 11, true);
    } else if (encoding === 2) {
      val = getStringUtf16(dv, -11, 11);
    }
    if (header.id === "TCON" && val !== null && !!parseInt(val)) {
      val = genres_default[parseInt(val)];
    }
    result.value = val;
  } else if (header.type === "W") {
    result.value = getString(dv, -10, 10);
  } else if (header.id === "PRIV") {
    const variableStart = 10;
    let variableLength = 0;
    for (let i = 0; ; i++) {
      if (dv.getUint8(i) === 0) {
        variableLength = i - variableStart;
        break;
      }
    }
    result.value = {
      identifier: variableLength === 0 ? null : getString(dv, variableLength, variableStart),
      data: buffer.slice(variableLength + variableStart + 1)
    };
  } else if (header.id === "COMM") {
    const encoding = dv.getUint8(10);
    let variableStart = 14;
    for (let i = variableStart; ; i++) {
      if (encoding === 1 || encoding === 2) {
        if (dv.getUint16(i) === 0) {
          variableStart = i + 2;
          break;
        }
        i++;
      } else {
        if (dv.getUint8(i) === 0) {
          variableStart = i + 1;
          break;
        }
      }
    }
    if (encoding === 0 || encoding === 3) {
      result.value = getString(dv, -1 * variableStart, variableStart);
    } else if (encoding === 1) {
      result.value = getStringUtf16(dv, -1 * variableStart, variableStart, true);
    } else if (encoding === 2) {
      result.value = getStringUtf16(dv, -1 * variableStart, variableStart);
    }
  } else if (header.id === "APIC") {
    const encoding = dv.getUint8(10);
    const image = {
      type: null,
      mime: null,
      description: null,
      data: null
    };
    let variableStart = 11;
    let variableLength = 0;
    for (let i = variableStart; ; i++) {
      if (dv.getUint8(i) === 0) {
        variableLength = i - variableStart;
        break;
      }
    }
    image.mime = getString(dv, variableLength, variableStart);
    image.type = imageTypes[dv.getUint8(variableStart + variableLength + 1)] || "other";
    variableStart += variableLength + 2;
    variableLength = 0;
    for (let i = variableStart; ; i++) {
      if (dv.getUint8(i) === 0) {
        variableLength = i - variableStart;
        break;
      }
    }
    if (variableLength !== 0) {
      if (encoding === 0 || encoding === 3) {
        image.description = getString(dv, variableLength, variableStart);
      } else if (encoding === 1) {
        image.description = getStringUtf16(dv, variableLength, variableStart, true);
      } else if (encoding === 2) {
        image.description = getStringUtf16(dv, variableLength, variableStart);
      }
    }
    image.data = buffer.slice(variableStart + 1);
    result.value = image;
  }
  return result.tag ? result : null;
}

// ../../node_modules/id3js/lib/id3Tag.js
async function parse2(handle) {
  let tag = null;
  const v1HeaderBuf = await handle.read(128, handle.size - 128);
  const v1Header = new DataView(v1HeaderBuf);
  if (v1HeaderBuf.byteLength === 128 && getString(v1Header, 3, void 0, true) === "TAG") {
    tag = {
      kind: "v1",
      title: getString(v1Header, 30, 3).trim() || null,
      album: getString(v1Header, 30, 63).trim() || null,
      artist: getString(v1Header, 30, 33).trim() || null,
      year: getString(v1Header, 4, 93).trim() || null,
      genre: null,
      comment: null,
      track: null
    };
    if (v1Header.getUint8(125) === 0) {
      tag.comment = getString(v1Header, 28, 97);
      tag.version = 1.1;
      tag.track = v1Header.getUint8(126);
    } else {
      tag.comment = getString(v1Header, 30, 97);
    }
    tag.genre = genres_default[v1Header.getUint8(127)] || null;
  }
  const v2PrefixBuf = await handle.read(14, 0);
  const v2Prefix = new DataView(v2PrefixBuf);
  if (v2PrefixBuf.byteLength === 14 && getString(v2Prefix, 3, void 0, true) === "ID3" && v2Prefix.getUint8(3) <= 4) {
    let headerSize = 10;
    let tagSize = 0;
    const version = [v2Prefix.getUint8(3), v2Prefix.getUint8(4)];
    const tagFlags = v2Prefix.getUint8(5);
    if ((tagFlags & 128) === 0) {
      tag = {
        kind: "v2",
        title: tag ? tag.title : null,
        album: tag ? tag.album : null,
        artist: tag ? tag.artist : null,
        year: tag ? tag.year : null,
        version,
        frames: [],
        images: []
      };
      if ((tagFlags & 64) !== 0) {
        headerSize += getUint32Synch(v2Prefix, 11);
      }
      tagSize += getUint32Synch(v2Prefix, 6);
      const v2TagBuf = await handle.read(tagSize, headerSize);
      const v2Tag = new DataView(v2TagBuf);
      let position = 0;
      while (position < v2TagBuf.byteLength) {
        let slice;
        let isFrame = true;
        for (let i = 0; i < 3; i++) {
          const frameBit = v2Tag.getUint8(position + i);
          if ((frameBit < 65 || frameBit > 90) && (frameBit < 48 || frameBit > 57)) {
            isFrame = false;
          }
        }
        if (!isFrame) {
          break;
        }
        if (version[0] < 3) {
          slice = v2TagBuf.slice(position, position + 6 + getUint24(v2Tag, position + 3));
        } else if (version[0] === 3) {
          slice = v2TagBuf.slice(position, position + 10 + v2Tag.getUint32(position + 4));
        } else {
          slice = v2TagBuf.slice(position, position + 10 + getUint32Synch(v2Tag, position + 4));
        }
        const frame = await parse(slice, version[0], version[1]);
        if (frame && frame.tag) {
          const tagAsV2 = tag;
          tagAsV2.frames.push(frame);
          if (frame.tag === "image") {
            tagAsV2.images.push(frame.value);
          } else {
            tag[frame.tag] = frame.value;
          }
        }
        position += slice.byteLength;
      }
    }
  }
  return tag;
}

// ../../node_modules/id3js/lib/browserFileReader.js
init_reader();
var BrowserFileReader = class extends Reader {
  /**
   * @param {File} file File to read
   */
  constructor(file) {
    super();
    this._file = file;
  }
  /** @inheritdoc */
  async open() {
    this.size = this._file.size;
  }
  /** @inheritdoc */
  async read(length, position) {
    const slice = this._file.slice(position, position + length);
    return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => {
        resolve(fr.result);
      };
      fr.onerror = () => {
        reject(new Error("File read failed"));
      };
      fr.readAsArrayBuffer(slice);
    });
  }
};

// ../../node_modules/id3js/lib/remoteReader.js
init_reader();

// ../../node_modules/id3js/lib/id3.js
var SUPPORTS_FILE = typeof window !== "undefined" && "File" in window && "FileReader" in window && typeof ArrayBuffer !== "undefined";
async function fromReader(reader) {
  await reader.open();
  const tags = await parse2(reader);
  await reader.close();
  return tags;
}
function fromFile(file) {
  if (!SUPPORTS_FILE) {
    throw new Error("Browser does not have support for the File API and/or ArrayBuffers");
  }
  return fromReader(new BrowserFileReader(file));
}
export {
  fromFile
};
//# sourceMappingURL=id3js.js.map
